// @core/api/endpoints/billing/resolve_billing_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveBillingContextRequest,
  ResolveBillingContextResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Resolve billing context
 * Resolves the effective billing policy for a scope entity by merging the policy hierarchy. Returns merged policy and available numbering schemes.
 */
export async function ResolveBillingContext(
  data: ResolveBillingContextRequest,
  options?: RequestOptions
): Promise<ResolveBillingContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/billing/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveBillingContextResponse>(requestPath, data, requestOptions);
}
